import axiosClient from "api/axios_client.js";

const apiEmailTemplate = {
  create:    (payload)     => axiosClient.post("/email-management/email-template/create", payload),
  update:    (id, payload) => axiosClient.put(`/email-management/email-template/update/${id}`, payload),
  getAllData: ()            => axiosClient.get("/email-management/email-template/get-all"),
  getById:   (id)          => axiosClient.get(`/email-management/email-template/get-by-id/${id}`),
  delete:    (id)          => axiosClient.delete("/email-management/email-template/delete", { data: { id } }),
  testTemplate: (id, payload) => axiosClient.post("/email-management/email-template/test-template", { id, ...payload }),
  testDraft:    (payload)     => axiosClient.post("/email-management/email-template/test-draft", payload),
  renderPreview: (payload)    => axiosClient.post("/email-management/email-template/render-preview", payload),
  aiGenerate:   (payload)     => axiosClient.post("/email-management/email-template/ai-generate", payload),
};

export default apiEmailTemplate;
